module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMjIuNyA0MDUuNyAyNDYuNCAxODkuNSI+DQoJPHBvbHlnb24gZmlsbD0iIzViNWI1YiIgcG9pbnRzPSItMzMuNCw1MjguOSAtOTAuMyw0NzYuOCAtMTIyLjcsNTEyLjIgLTMxLjksNTk1LjMgMTIzLjcsNDM5LjcgODkuOCw0MDUuNyAiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/images/tick.svg
// module id = 273
// module chunks = 70144966829960 73875541826398 169315112914517